import { configureStore } from '@reduxjs/toolkit';
import { rootReducer } from 'store/root-reducer';
import { envSlice } from 'store/env-slice';
import { dataFromParentMicrofrontSlice } from 'store/data-from-parent-microfront-slice';
import createSagaMiddleware from 'redux-saga';
import { rootSaga } from 'store/root-saga';
import { projectsSlice } from 'app-entities/projects/projects-slice';

type TProps = {
  preloadedState: {
    env: ReturnType<typeof envSlice.reducer>;
    dataFromParentMicrofront: ReturnType<typeof dataFromParentMicrofrontSlice.reducer>;
    projects?: ReturnType<typeof projectsSlice.reducer>;
  };
};

export const createStore = ({ preloadedState }: TProps) => {
  const sagaMiddleware = createSagaMiddleware();

  const store = configureStore({
    reducer: rootReducer,
    preloadedState: preloadedState,
    middleware: getDefaultMiddleware => {
      return getDefaultMiddleware().concat(sagaMiddleware);
    },
  });

  sagaMiddleware.run(rootSaga);

  return {
    store,
  };
};

export type TStoreFromCreateStore = ReturnType<typeof createStore>['store'];

export type TRootState = ReturnType<TStoreFromCreateStore['getState']>;
